import { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { State } from "../../../store";
import { findUserTokenInStorage } from "../../../store/auth/authActions";
import authInterceptor from "../../../api/authInterceptor";

export default function useAuth() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const store = useStore();
  const userToken = useSelector(
    (state: State) => state.auth.userToken,
    (oldToken, newToken) => oldToken.sessionToken === newToken.sessionToken
  );
  const isLoggedIn = useSelector((state: State) => state.auth.isLoggedIn);

  useLayoutEffect(() => {
    dispatch(findUserTokenInStorage());
  }, [dispatch]);

  useLayoutEffect(() => {
    authInterceptor(userToken.sessionToken);
    // Czytamy bieżący stan sklepu (nie wartość z rendera) –
    // po findUserTokenInStorage store może już mieć loading: true z trwającego refreshu
    if (!(store.getState() as State).auth.loading) {
      setLoading(false);
    }
  }, [userToken, store]);

  return { isLoggedIn, loading };
}
